import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Container from "./components/Container";
import Field from "./components/Field";
import Button from "./components/Button";
import Grid from "./components/Grid";
import ProviderCard from "./components/ProviderCard";
import RatingStamp from "./components/RatingStamp";
import EmptyState from "./components/EmptyState";
import { CATEGORIES } from "./categories";
import { updateEmail, updatePhone, myListings, getAvgRating } from "./api";
import styles from "./Profile.module.css";

const labelFor = (value) => CATEGORIES.find((c) => c.value === value)?.label || value;

export default function Profile() {
  const history = useHistory();
  const username = localStorage.getItem("username") || "";
  const usertype = localStorage.getItem("usertype") || "USER";
  const isSP = usertype === "SP";

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [rating, setRating] = useState(0);
  const [listings, setListings] = useState([]);
  const [listingsLoaded, setListingsLoaded] = useState(false);

  useEffect(() => {
    if (!isSP) return;
    (async () => {
      try {
        const listRes = await myListings(localStorage.getItem("user_id"));
        setListings(Array.isArray(listRes.data) ? listRes.data : []);
        const rateRes = await getAvgRating(localStorage.getItem("user_id"));
        setRating(Number(rateRes.data?.[0]?.rating) || 0);
      } catch (error) {
        console.log(error);
      } finally {
        setListingsLoaded(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveEmail = async () => {
    try {
      const res = await updateEmail(localStorage.getItem("user_id"), email);
      if (res.data.message === "updated") {
        localStorage.setItem("email", email);
        toast.success("Email updated!");
        setEmail("");
      } else toast.error("Update unsuccessful. Try again.");
    } catch {
      toast.error("Update unsuccessful. Try again.");
    }
  };

  const savePhone = async () => {
    try {
      const res = await updatePhone(localStorage.getItem("user_id"), phone);
      if (res.data.message === "updated") {
        localStorage.setItem("userphone", phone);
        toast.success("Phone updated!");
        setPhone("");
      } else toast.error("Update unsuccessful. Try again.");
    } catch {
      toast.error("Update unsuccessful. Try again.");
    }
  };

  const logout = () => {
    localStorage.clear();
    localStorage.setItem("user_id", "");
    history.push("/");
    toast.success("Logged out!");
  };

  return (
    <div>
      <Nav />
      <main className={styles.page}>
        <Container>
          <div className={styles.header}>
            <h1 className={styles.title}>Your profile</h1>
            <Button variant="secondary" onClick={logout}>
              Log out
            </Button>
          </div>

          <div className={styles.card}>
            <div className={styles.identity}>
              <span className={styles.avatar} aria-hidden="true">
                {username.slice(0, 1).toUpperCase() || "U"}
              </span>
              <div>
                <p className={styles.uname}>{username}</p>
                <span className={styles.utype}>{isSP ? "Service provider" : "Customer"}</span>
              </div>
            </div>

            <div className={styles.editRow}>
              <Field
                id="email"
                label="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={localStorage.getItem("email") || "your@email.com"}
              />
              <Button onClick={saveEmail}>Update</Button>
            </div>

            <div className={styles.editRow}>
              <Field
                id="phone"
                label="Phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder={localStorage.getItem("userphone") || "10-digit number"}
              />
              <Button onClick={savePhone}>Update</Button>
            </div>
          </div>

          <div className={styles.section}>
            <Button variant="secondary" onClick={() => history.push("/registerservices")}>
              {isSP ? "List another service" : "Become a provider"}
            </Button>
          </div>

          {isSP && (
            <section className={styles.section}>
              <h2 className={styles.h2}>Your rating</h2>
              <div className={styles.ratingRow}>
                <RatingStamp value={rating} />
                <Button variant="ghost" onClick={() => history.push("/comments")}>
                  View comments
                </Button>
              </div>

              <h2 className={styles.h2}>My listings</h2>
              {listings.length > 0 ? (
                <Grid min="240px">
                  {listings.map((l, i) => (
                    <ProviderCard
                      key={i}
                      name={labelFor(l.service_category)}
                      trade="Listing"
                      pincode={l.pincode}
                      rating={rating}
                    />
                  ))}
                </Grid>
              ) : (
                listingsLoaded && (
                  <EmptyState title="No listings yet" message="List a service to start getting bookings." />
                )
              )}
            </section>
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
}
